<template>
<div style="margin:0 auto;width: 830px;background: #131518;height: 100%" >
  
  <div class="panel-heading"><h4 class="panel-title">게임 정보 </h4></div>
  <div class="col-md-12">
    <div class="table-responsive">
      <table class="table table-bordered mb-0 align-middle table-dark">
        <tbody>
          <tr>
            <td>게임명</td>
            <td>{{table.name}}</td>
            <td>게임타입</td>
            <td>{{gameType}}</td>
          </tr>
          <tr>
            <td>벤더</td>
            <td>{{gameProvider}}</td>
            <td>딜러</td><td>{{dealer.name}}</td>
          </tr>
          <tr>
            <td>게임 시작시간</td>
            <td>{{settledAt}}</td>
            <td>상태</td><td>{{status}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
	
<div class="panel-heading"><h4 class="panel-title mb-0"> 게임 결과 </h4></div>
<div class="d-flex">
  <div class="col-md-6">
    <div class="card mt-2">
       <div class="text-center" ><img  v-for="(item,index) in banker_cards" :key="index" :index="index" :src="'https://backoffice.honorlink.org/assets/img/trump/'+item+'.png'" class="card-img-top w-100px m-1" ></div>
    <div class="text-center">
      <div class="mb-2"><span class="badge bg-danger fs-15px">Banker</span></div>
      <div><h4 class="card-title mb-0 text-white">Score : <span class="text-warning fw-bold">{{banker.score}}</span></h4></div>
    </div>
    <div class="card-footer" style="padding:5px 0">
      <div class="table-responsive mb-0">
        <table class="table  mytable-bordered table-hover align-middle text-center">
          <thead><tr><th>베팅</th><th>베팅금액</th><th>지불금액</th></tr></thead>
          <tbody >

            <tr v-for="(item,index) in BAC_Banker" :key="index" :index="index">
              <td>{{item.description}}</td>
              <td><span class="text-success">{{formatMoney(item.stake)}}</span></td>
              <td><span class="text-warning">{{formatMoney(item.payout)}}</span></td></tr>


            </tbody></table></div></div>
    </div>
   
  </div>
   <div class="col-md-6">
    <div class="card mt-2">
       <div class="text-center"><img  v-for="(item,index) in player_cards" :key="index" :index="index" :src="'https://backoffice.honorlink.org/assets/img/trump/'+item+'.png'" class="card-img-top w-100px m-1" ></div>
    <div class="text-center">
      <div class="mb-2"><span class="badge bg-primary fs-15px">Player</span></div>
      <div><h4 class="card-title mb-0 text-white">Score : <span class="text-warning fw-bold">{{player.score}}</span></h4></div>
    </div>
    <div class="card-footer" style="padding:5px 0"><div class="table-responsive mb-0"><table class="table table-hover mytable-bordered align-middle text-center"><thead><tr><th>베팅</th><th>베팅금액</th><th>지불금액</th></tr></thead><tbody><!---->
      <tr v-for="(item,index) in BAC_Player" :key="index" :index="index"><td>{{item.description}}</td><td><span class="text-success">{{formatMoney(item.stake)}}</span></td><td><span class="text-warning">{{formatMoney(item.payout)}}</span></td></tr>
    </tbody></table></div></div>
    </div>
   
  </div>

</div>
   <div class="d-flex">
     <div class="col-md-6">
    <div class="card mt-2">
      <div class="card-body text-center" style="padding:5px 0"><span class="badge bg-success fs-15px">Tie</span></div>
      <div class="card-footer" style="padding:5px 0"><div class="table-responsive mb-0"><table class="table table-hover mytable-bordered align-middle text-center"><thead><tr><th>베팅</th><th>베팅금액</th><th>지불금액</th></tr></thead><tbody><!----><tr v-for="(item,index) in BAC_Tie" :key="index" :index="index"><td>{{item.description}}</td><td><span class="text-success">{{formatMoney(item.stake)}}</span></td><td><span class="text-warning">{{formatMoney(item.payout)}}</span></td></tr></tbody></table></div></div>
    </div>
  </div>
   <div class="col-md-6">
    <div class="card mt-2">
      <div class="card-body text-center" style="padding:5px 0"><span class="badge bg-muted  fs-15px">Etc</span></div>
      <div class="card-footer" style="padding:5px 0"><div class="table-responsive mb-0"><table class="table table-hover mytable-bordered align-middle text-center"><thead><tr><th>베팅</th><th>베팅금액</th><th>지불금액</th></tr></thead><tbody><!----><tr v-for="(item,index) in BAC_Etc" :key="index" :index="index"><td>{{item.description}}</td><td><span class="text-success">{{formatMoney(item.stake)}}</span></td><td><span class="text-warning">{{formatMoney(item.payout)}}</span></td></tr></tbody></table></div></div>
    </div>
  </div>
   </div>
    <div class="panel-heading mt-2"><h4 class="panel-title mb-0"> 게임 요약  </h4></div>
     <div class="col-md-12">
	<div class="table-responsive">
    <table class="table mb-0 align-middle mytable-bordered mt-2">
      <tbody>
        <tr>
          <td class="col-md-3" style="border-top: none;">결과</td>
          <td class="col-md-9" style="border-top: none;"><span class="bg-danger" style="padding:5px 8px;border-radius: 5px;">{{outcome}}</span></td>
        </tr>
        <tr><td class="col-md-3">총 베팅금액</td>
          <td class="col-md-9 text-yellow">{{formatMoney(totalStake)}}</td></tr><tr><td class="col-md-3-md-4">총 지불금액</td><td class="col-md-9 text-warning">{{formatMoney(totalPayout)}}</td></tr></tbody></table></div>	</div>		
				
</div>
 </template>

 <script>
 
    export default {
   
       props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
     BAC_Banker:{
        type:Array,
        default:()=>{
          return {}
        }
        
      },
      BAC_Tie:{
        type:Array,
        default:()=>{
          return {}
        }
      },
      BAC_Player:{
        type:Array,
        default:()=>{
          return {}
        }
        
      },
       BAC_Etc:{
        type:Array,
        default:()=>{
          return {}
        }
        
      },
      banker_cards:{
        type:Array,
        default:()=>[]
        
      },
      player_cards:{
        type:Array,
        default:()=>[]
        
      },
      banker:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      player:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      totalStake:{
        type:Number,
        default:""
      },
      totalPayout:{
        type:Number,
        default:""
      },
      outcome:{
        type:String,
        default:""
      },
      gameProvider:{
        type:String,
        default:""
      },
       gameType:{
        type:String,
        default:""
      },
      status:{
        type:String,
        default:""
      },
      settledAt:{
        type:String,
        default:""
      },
      dealer:{
        type:Object,
        default:()=>{
          return {}
        }
      },
     table:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    },
    	data(){
    		return{
    			domain:window.sessionStorage.getItem('domain'),
          power:window.sessionStorage.getItem('power'),
    			tranLoading:false,
			       
			         
    			}
    			
    			
    		},
    		created() {
        
          console.log('id',this.info.id)
        console.log(this.banker_cards)
         // this.info.id父组件传给子组件的id值
  

       

        
         

          
             
    },
    	
    	methods:{
          
    	

    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
  .table th,.table td{
    padding:6px;
  }
  .bg-muted{background-color: #666}
 .mytable-bordered thead th, .mytable-bordered td{
  color: #fff;
 }
 .mytable-bordered thead th{
  border-top: 1px solid #5a5a5a;border-bottom: 1px solid #5a5a5a;
 }
 .mytable-bordered td{
  border-top: 1px solid #5a5a5a;
 }
  .panel-heading{
    background-color: #000;color: #fff;
  }
  .card{
    background-color: #0f1113;
    border:1px solid #28292c;
  }
  .panel-title{
    padding:10px 15px; margin-bottom:5px;font-size: 16px;
  }
 
.w-100px, .w-xs-100px {
    width: 60px!important;
}
.m-1 {
    margin: 10px !important;
}
.badge {
  margin-top: 10px;
    display: inline-block;
    font-size: 18px;
    padding:8px 10px;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    border-radius: 4px;}
    body .layer_bg .layui-layer-content{

background-color: #131518;

}

</style>


// WEBPACK FOOTER //
// src/components/common/transaction.vue